/**
 * Metadati <head> dell'area Drive. Lo script inline di public/index.html li applica
 * prima del primo paint quando si apre direttamente /autista*; questa funzione li
 * applica (e li ripristina) quando si entra in Drive navigando dentro la SPA.
 * I valori devono coincidere con quelli dello script inline (c'è un test).
 */
export const DRIVE_MANIFEST = "/drive/manifest.webmanifest";
export const DRIVE_VIEWPORT = "width=device-width, initial-scale=1, viewport-fit=cover";
export const DRIVE_THEME_LIGHT = "#f8fafc";
export const DRIVE_THEME_DARK = "#18181f";
export const DRIVE_APPLE_ICON = "/drive/icons/drive-apple-touch-180.png";
export const DRIVE_TITLE = "Drive";

export function isDrivePath(p) {
  return p === "/autista" || String(p || "").startsWith("/autista/") || p === "/autista-login";
}

function setAttr(sel, attr, val, saved) {
  const el = document.head.querySelector(sel);
  if (!el) return;
  saved.push([el, attr, el.getAttribute(attr)]);
  el.setAttribute(attr, val);
}

/** Applica i metadati Drive; restituisce una funzione che ripristina quelli originali. */
export function applyDriveHead() {
  if (typeof document === "undefined") return () => {};
  if (document.documentElement.getAttribute("data-app") === "drive" && document.head.querySelector('meta[data-drive="1"]')) {
    return () => {}; // già applicati dallo script inline: restano per tutta la sessione
  }
  const saved = [];
  setAttr('link[rel="manifest"]', "href", DRIVE_MANIFEST, saved);
  setAttr('meta[name="viewport"]', "content", DRIVE_VIEWPORT, saved);
  setAttr('meta[name="theme-color"]', "content", DRIVE_THEME_LIGHT, saved);
  setAttr('meta[name="theme-color"]', "media", "(prefers-color-scheme: light)", saved);
  setAttr('meta[name="apple-mobile-web-app-title"]', "content", DRIVE_TITLE, saved);
  setAttr('meta[name="application-name"]', "content", DRIVE_TITLE, saved);
  setAttr('link[rel="apple-touch-icon"]', "href", DRIVE_APPLE_ICON, saved);
  const dark = document.createElement("meta");
  dark.name = "theme-color";
  dark.content = DRIVE_THEME_DARK;
  dark.setAttribute("media", "(prefers-color-scheme: dark)");
  dark.setAttribute("data-drive", "spa");
  document.head.appendChild(dark);
  document.documentElement.setAttribute("data-app", "drive");
  return () => {
    for (let i = saved.length - 1; i >= 0; i -= 1) {
      const [el, attr, val] = saved[i];
      if (val === null) el.removeAttribute(attr);
      else el.setAttribute(attr, val);
    }
    dark.remove();
    document.documentElement.removeAttribute("data-app");
  };
}
